// extracted by mini-css-extract-plugin
module.exports = {"container":"virtualAssistantQuestionLabel_container__2otZr"};
    if(module.hot) {
      // 1790670292874
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  